document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-kwo-baitfinder]').forEach(function (root) {
    var configEl = root.querySelector('[data-kwo-bf-config]');
    if (!configEl) return;
    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    function parsePoints(str) {
      var out = {};
      (str || '').split(',').forEach(function (pair) {
        var parts = pair.split(':');
        var key = (parts[0] || '').trim();
        var val = parseFloat(parts[1]);
        if (key && !isNaN(val)) out[key] = val;
      });
      return out;
    }

    var questions = (config.questions || [])
      .map(function (q) {
        return {
          label: q.label,
          options: (q.options || []).map(function (o) {
            return {
              id: o.id,
              label: o.label,
              points: parsePoints(o.points),
              forceWinner: o.forceWinner || null,
              tiePref: o.tiePref || null,
              size: o.size || null,
              tip: o.tip || null
            };
          })
        };
      })
      .filter(function (q) {
        return q.options.length > 0;
      });

    var flavors = config.flavors || {};
    var tieBreakOrder = config.tieBreakOrder || [];
    var answers = questions.map(function () {
      return 0;
    });

    function computeResult() {
      for (var qi = 0; qi < questions.length; qi++) {
        var opt = questions[qi].options[answers[qi]];
        if (opt && opt.forceWinner && flavors[opt.forceWinner]) {
          return finalize(opt.forceWinner);
        }
      }

      var scores = {};
      Object.keys(flavors).forEach(function (k) {
        scores[k] = 0;
      });
      questions.forEach(function (q, qi) {
        var opt = q.options[answers[qi]];
        if (!opt) return;
        Object.keys(opt.points).forEach(function (k) {
          if (k in scores) scores[k] += opt.points[k];
        });
      });

      var keys = Object.keys(scores);
      if (!keys.length) return null;
      var max = Math.max.apply(
        null,
        keys.map(function (k) {
          return scores[k];
        })
      );
      var leaders = keys.filter(function (k) {
        return scores[k] === max;
      });

      var winner;
      if (leaders.length === 1) {
        winner = leaders[0];
      } else {
        var pref = null;
        for (var qi2 = 0; qi2 < questions.length && !pref; qi2++) {
          var opt2 = questions[qi2].options[answers[qi2]];
          if (opt2 && opt2.tiePref && leaders.indexOf(opt2.tiePref) !== -1) pref = opt2.tiePref;
        }
        winner =
          pref ||
          tieBreakOrder.filter(function (k) {
            return leaders.indexOf(k) !== -1;
          })[0] ||
          leaders[0];
      }
      return finalize(winner);
    }

    function finalize(winnerKey) {
      var flavor = flavors[winnerKey];
      if (!flavor) {
        var fallbackKey =
          Object.keys(flavors).filter(function (k) {
            return flavors[k].isDefault;
          })[0] || Object.keys(flavors)[0];
        flavor = flavors[fallbackKey];
        winnerKey = fallbackKey;
      }
      if (!flavor) return null;

      var size = null;
      questions.forEach(function (q, qi) {
        var opt = q.options[answers[qi]];
        if (opt && opt.size) size = opt.size;
      });
      var product =
        size === 'long'
          ? flavor.productLong && flavor.productLong.name
            ? flavor.productLong
            : flavor.productShort
          : flavor.productShort && flavor.productShort.name
          ? flavor.productShort
          : flavor.productLong;

      var tip = null;
      questions.forEach(function (q, qi) {
        var opt = q.options[answers[qi]];
        if (!tip && opt && opt.tip) tip = opt.tip;
      });

      return {
        key: winnerKey,
        name: flavor.name,
        tag: flavor.tag,
        why: flavor.why,
        tip: tip,
        product: product
      };
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function renderQuestions(container, optionClass, groupClass, labelClass) {
      if (!container) return;
      container.innerHTML = '';
      questions.forEach(function (q, qi) {
        var wrap = document.createElement('div');
        var label = document.createElement('div');
        label.className = labelClass;
        label.textContent = qi + 1 + ' · ' + q.label;
        var opts = document.createElement('div');
        opts.className = groupClass;
        q.options.forEach(function (o, oi) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = optionClass + (answers[qi] === oi ? ' is-active' : '');
          btn.textContent = o.label;
          btn.addEventListener('click', function () {
            answers[qi] = oi;
            renderAll();
          });
          opts.appendChild(btn);
        });
        wrap.appendChild(label);
        wrap.appendChild(opts);
        container.appendChild(wrap);
      });
    }

    function renderRec(container, result) {
      if (!container) return;
      if (!result) {
        container.innerHTML = '';
        return;
      }
      var html = '';
      html += '<div class="kwo-baitfinder__card-kicker">' + escapeHtml(config.resultKicker || '') + '</div>';
      html += '<div class="kwo-baitfinder__card-top">';
      html +=
        '<div class="kwo-baitfinder__card-thumb">' +
        (result.product && result.product.image
          ? '<img src="' + escapeHtml(result.product.image) + '" alt="" loading="lazy">'
          : '') +
        '</div>';
      html +=
        '<div><div class="kwo-baitfinder__card-name">' +
        escapeHtml(result.name) +
        '</div><div class="kwo-baitfinder__card-sub">' +
        escapeHtml(result.tag || '') +
        '</div></div>';
      html += '</div>';
      if (result.why) html += '<p class="kwo-baitfinder__card-desc">' + escapeHtml(result.why) + '</p>';
      if (result.tip) html += '<div class="kwo-baitfinder__card-tip">ⓘ ' + escapeHtml(result.tip) + '</div>';
      if (result.product && result.product.name) {
        html += '<div class="kwo-baitfinder__card-product">';
        html +=
          '<div class="kwo-baitfinder__card-product-thumb">' +
          (result.product.image
            ? '<img src="' + escapeHtml(result.product.image) + '" alt="" loading="lazy">'
            : '') +
          '</div>';
        html +=
          '<div style="flex:1;min-width:0;"><div class="kwo-baitfinder__card-product-name">' +
          escapeHtml(result.product.name) +
          '</div>';
        html +=
          '<div class="kwo-baitfinder__card-price-row"><span class="kwo-baitfinder__card-price">' +
          escapeHtml(result.product.price || '') +
          '</span>';
        if (result.product.comparePrice) {
          html += '<span class="kwo-baitfinder__card-old">' + escapeHtml(result.product.comparePrice) + '</span>';
        }
        html += '</div></div></div>';
      }
      var canAdd = result.product && result.product.variantId;
      html +=
        '<button type="button" class="kwo-baitfinder__cta" data-kwo-bf-add' +
        (canAdd ? '' : ' disabled') +
        '>' +
        escapeHtml(config.ctaText || 'Toevoegen aan winkelwagen') +
        '</button>';
      container.innerHTML = html;

      var addBtn = container.querySelector('[data-kwo-bf-add]');
      if (addBtn && canAdd) {
        addBtn.addEventListener('click', function () {
          addToCart(result.product.variantId, addBtn);
        });
      }
    }

    function addToCart(variantId, btn) {
      var original = btn.textContent;
      btn.disabled = true;
      var root2 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root2 + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = config.ctaAddedText || 'Toegevoegd ✓';
          btn.classList.add('is-added');
          if (window.eventBus) window.eventBus.emit('open:cart:drawer');
          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 2500);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
        });
    }

    function renderAll() {
      var result = computeResult();
      renderQuestions(
        root.querySelector('[data-kwo-bf-questions="desktop"]'),
        'kwo-baitfinder__opt',
        'kwo-baitfinder__opts',
        'kwo-baitfinder__qlabel'
      );
      renderQuestions(
        root.querySelector('[data-kwo-bf-questions="mobile"]'),
        'kwo-baitfinder__mob-opt',
        'kwo-baitfinder__mob-opts',
        'kwo-baitfinder__mob-qlabel'
      );
      renderRec(root.querySelector('[data-kwo-bf-rec="desktop"]'), result);
      renderRec(root.querySelector('[data-kwo-bf-rec="mobile"]'), result);
    }

    var mobileToggle = root.querySelector('[data-kwo-bf-mob-toggle]');
    if (mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        var mobile = mobileToggle.closest('[data-kwo-bf-mobile]');
        if (mobile) mobile.classList.toggle('is-open');
      });
    }

    if (questions.length) renderAll();
  });
});
